import React from 'react'

import { Button } from "/react4xp/shared/button/button";

export default (props) => <Button {...props} />
